<script setup>
const vacanciesStore = useVacanciesStore();
const route = useRoute();

const requests = [
  useAsyncData(() => vacanciesStore.fetchVacancy(route.params.vacancySlug)),
];

if (!vacanciesStore.groups) {
  requests.push(vacanciesStore.fetchGroups());
}

const [{ data: vacancyData, error: vacancyError }] =
  await Promise.all(requests);

if (vacancyError.value) {
  const { statusCode, statusMessage } = vacancyError.value;
  throw createError({ statusCode, statusMessage, fatal: true });
}

const groupData = computed(() =>
  vacanciesStore.getGroupById(vacancyData.value.groupId),
);

const backUrl = computed(() => `/vacancies/${route.params.vacancySlug}`);
</script>

<template>
  <div class="pages-vacancies-vacancy-slug-form">
    <BundlesHead
      :title="$t('vacancies.form.title')"
      :subtitle="vacancyData.name"
      :caption="groupData.name"
      :back-text="$t('vacancies.form.back')"
      :back-url="backUrl"
    />

    <CtrSidebar icon="/images/pen.svg">
      <template #content>
        <CtrVacancyForm in-sidebar />
      </template>
    </CtrSidebar>
  </div>
</template>

<style scoped lang="scss">
.pages-vacancies-vacancy-slug-form {
  padding-top: em($gap-page-title);
  padding-bottom: em(160);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(74);
  }
}
</style>
